import { createFileRoute, redirect } from "@tanstack/react-router";

function CalendarDetail() {
  return <div>Hello /_authenticated/calendar/$calendarId/!</div>;
}

export const Route = createFileRoute("/_authenticated/calendar/$calendarId/")({
  beforeLoad: ({ params }) => {
    if (params.calendarId === "all") {
      throw redirect({ to: "/calendars" });
    }
  },
  component: () => <CalendarDetail />,
});
